import { Button, DataHeader, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceRateTable extends Layout {
    buttonAddColumn: Button;
    buttonAddRow: Button;
    buttonAdjustRates: Button;
    buttonCopy: Button;
    buttonCreateTable: Button;
    dataheaderDistanceRateTable: DataHeader;
    labelDistance: Label;
    labelRates: Label;
    labelWeight: Label;
    panelLower: Panel;
    panelRateTable: Panel;
    panelRates: Panel;
    panelTableTools: Panel;
    panelUpper: Panel;
    sourceMileageRate: DataSource;
    sourceRateHeader: DataSource;
    textboxCurrency: Textbox;
    textboxId: Textbox;
    textboxLtl: Textbox;
    textboxMethod: Textbox;
    textboxMinimumWeight: Textbox;
    textboxRemark: Textbox;
}
